import RenewalOrderBatchManualModal from './renewal-order-batch-manual-modal.vue'
export default RenewalOrderBatchManualModal
